const bannersTypesApi = ({ apiClient }) => ({
  list(params) {
    return apiClient.get('banner-types', {}, params)
  },
  show(id, params) {
    return apiClient.get(`banner-types/${id}`, {}, params)
  },
})

export default bannersTypesApi
